export enum Platform {
  ANDROID = 0,
  IOS = 1,
  WINDOWS = 2,
  MAC = 3,
  LINUX = 4,
}

export function getPlatform(userAgent: string): Platform {
  if (userAgent.match(/Android/)) return Platform.ANDROID;
  if (userAgent.match(/iPhone|iPad|iPod/)) return Platform.IOS;
  if (userAgent.match(/Mac/)) return Platform.MAC;
  if (userAgent.match(/Windows/)) return Platform.WINDOWS;
  return Platform.LINUX;
}
